import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp, FiCalendar, FiMapPin, FiUsers, FiAward, FiBookOpen, FiHome } from "react-icons/fi";

class MuseumHistory extends Component {
    render() {
        return (
            <React.Fragment>
                <PageHelmet pageTitle='ประวัติของพิพิธภัณฑ์' />
                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.webp" />

                {/* Hero Section */}
                <div className="hero-section" style={{
                    background: 'linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url("/assets/images/singha/floor1/IMG_7802.webp")',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    minHeight: '60vh',
                    display: 'flex',
                    alignItems: 'center',
                    position: 'relative'
                }}>
                    <div className="container">
                        <div className="row justify-content-center text-center">
                            <div className="col-lg-8">
                                <h1 className="hero-title" style={{
                                    color: 'white',
                                    fontSize: '3.5rem',
                                    fontWeight: 'bold',
                                    marginBottom: '1rem',
                                    textShadow: '2px 2px 4px rgba(0,0,0,0.7)'
                                }}>
                                    ประวัติของพิพิธภัณฑ์
                                </h1>
                                <p className="hero-subtitle" style={{
                                    color: 'white',
                                    fontSize: '1.2rem',
                                    opacity: 0.9,
                                    textShadow: '1px 1px 2px rgba(0,0,0,0.7)'
                                }}>
                                    จากแนวคิดสู่ความเป็นจริง เรื่องราวการก่อสร้างพิพิธภัณฑ์สิงห์ท่า
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Timeline Section */}
                <div className="timeline-section ptb--50" style={{ backgroundColor: '#f8f9fa' }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                <div className="section-title text-center mb-5">
                                    <h2 className="title" style={{
                                        fontSize: '2.5rem',
                                        fontWeight: 'bold',
                                        color: '#242424',
                                        marginBottom: '1rem'
                                    }}>
                                        เส้นเวลาการพัฒนา
                                    </h2>
                                    <p className="description" style={{
                                        fontSize: '1.5rem',
                                        color: '#666',
                                        maxWidth: '600px',
                                        margin: '0 auto'
                                    }}>
                                        ตามรอยการพัฒนาพิพิธภัณฑ์สิงห์ท่าจากจุดเริ่มต้นสู่ปัจจุบัน
                                    </p>
                                </div>

                                {/* Timeline */}
                                <div className="timeline-container" style={{ position: 'relative' }}>
                                    {/* Timeline Line */}
                                    <div className="timeline-line" style={{
                                        position: 'absolute',
                                        left: '50%',
                                        top: 0,
                                        bottom: 0,
                                        width: '4px',
                                        backgroundColor: '#F45354',
                                        transform: 'translateX(-50%)',
                                        zIndex: 1
                                    }}></div>

                                    {/* Timeline Items */}
                                    <div className="timeline-item" style={{
                                        display: 'flex',
                                        marginBottom: '4rem',
                                        position: 'relative',
                                        zIndex: 2
                                    }}>
                                        <div className="timeline-content left" style={{
                                            width: '45%',
                                            paddingRight: '3rem',
                                            textAlign: 'right'
                                        }}>
                                            <div className="timeline-card" style={{
                                                backgroundColor: 'white',
                                                padding: '2rem',
                                                borderRadius: '15px',
                                                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                                                borderLeft: '4px solid #F45354',
                                                // Mobile responsive styles
                                                '@media (max-width: 768px)': {
                                                    width: '100%',
                                                    margin: '0 1rem',
                                                    padding: '1.5rem'
                                                }
                                            }}>
                                                <div className="timeline-icon" style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    width: '60px',
                                                    height: '60px',
                                                    backgroundColor: '#F45354',
                                                    borderRadius: '50%',
                                                    marginBottom: '1rem'
                                                }}>
                                                    <FiCalendar style={{ color: 'white', fontSize: '1.5rem' }} />
                                                </div>
                                                <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '0.5rem', color: '#242424' }}>
                                                    พ.ศ. 2560
                                                </h3>
                                                <h4 style={{ fontSize: '1.2rem', fontWeight: '600', marginBottom: '1rem', color: '#F45354' }}>
                                                    การริเริ่มโครงการ
                                                </h4>
                                                <p style={{ color: '#666', lineHeight: '1.6' }}>
                                                    นายบุญธรรม เลิศสุขีเกษม <br></br>ผู้ว่าราชการจังหวัดยโสธร ได้ริเริ่มโครงการจัดสร้างพิพิธภัณฑ์เมืองเก่าบ้านสิงห์ท่า
                                                </p>
                                            </div>
                                        </div>
                                        <div className="timeline-dot" style={{
                                            position: 'absolute',
                                            left: '50%',
                                            top: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            width: '20px',
                                            height: '20px',
                                            backgroundColor: '#F45354',
                                            borderRadius: '50%',
                                            border: '4px solid white',
                                            boxShadow: '0 0 0 4px #F45354'
                                        }}></div>
                                        <div className="timeline-content right" style={{ width: '45%' }}></div>
                                    </div>

                                    <div className="timeline-item" style={{
                                        display: 'flex',
                                        marginBottom: '4rem',
                                        position: 'relative',
                                        zIndex: 2
                                    }}>
                                        <div className="timeline-content left" style={{ width: '45%' }}></div>
                                        <div className="timeline-dot" style={{
                                            position: 'absolute',
                                            left: '50%',
                                            top: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            width: '20px',
                                            height: '20px',
                                            backgroundColor: '#F45354',
                                            borderRadius: '50%',
                                            border: '4px solid white',
                                            boxShadow: '0 0 0 4px #F45354'
                                        }}></div>
                                        <div className="timeline-content right" style={{
                                            width: '45%',
                                            paddingLeft: '6rem'
                                        }}>
                                            <div className="timeline-card" style={{
                                                backgroundColor: 'white',
                                                padding: '2rem',
                                                borderRadius: '15px',
                                                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                                                borderRight: '4px solid #F45354'
                                            }}>
                                                <div className="timeline-icon" style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    width: '60px',
                                                    height: '60px',
                                                    backgroundColor: '#F45354',
                                                    borderRadius: '50%',
                                                    marginBottom: '1rem'
                                                }}>
                                                    <FiHome style={{ color: 'white', fontSize: '1.5rem' }} />
                                                </div>
                                                <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '0.5rem', color: '#242424' }}>
                                                    พ.ศ. 2561
                                                </h3>
                                                <h4 style={{ fontSize: '1.2rem', fontWeight: '600', marginBottom: '1rem', color: '#F45354' }}>
                                                    การก่อสร้างแล้วเสร็จ
                                                </h4>
                                                <p style={{ color: '#666', lineHeight: '1.6' }}>
                                                    การก่อสร้างอาคารพิพิธภัณฑ์ในรูปแบบโคโลเนี่ยลแล้วเสร็จ และเปิดดำเนินการชั่วคราว
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="timeline-item" style={{
                                        display: 'flex',
                                        marginBottom: '4rem',
                                        position: 'relative',
                                        zIndex: 2
                                    }}>
                                        <div className="timeline-content left" style={{
                                            width: '45%',
                                            paddingRight: '3rem',
                                            textAlign: 'right'
                                        }}>
                                            <div className="timeline-card" style={{
                                                backgroundColor: 'white',
                                                padding: '2rem',
                                                borderRadius: '15px',
                                                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                                                borderLeft: '4px solid #F45354'
                                            }}>
                                                <div className="timeline-icon" style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    width: '60px',
                                                    height: '60px',
                                                    backgroundColor: '#F45354',
                                                    borderRadius: '50%',
                                                    marginBottom: '1rem'
                                                }}>
                                                    <FiUsers style={{ color: 'white', fontSize: '1.5rem' }} />
                                                </div>
                                                <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '0.5rem', color: '#242424' }}>
                                                    พ.ศ. 2563
                                                </h3>
                                                <h4 style={{ fontSize: '1.2rem', fontWeight: '600', marginBottom: '1rem', color: '#F45354' }}>
                                                    การส่งมอบ
                                                </h4>
                                                <p style={{ color: '#666', lineHeight: '1.6' }}>
                                                    จังหวัดยโสธรได้ส่งมอบอาคารพิพิธภัณฑ์เมืองเก่าบ้านสิงห์ท่าให้เทศบาลเมืองยโสธรเป็นผู้ดูแล
                                                </p>
                                            </div>
                                        </div>
                                        <div className="timeline-dot" style={{
                                            position: 'absolute',
                                            left: '50%',
                                            top: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            width: '20px',
                                            height: '20px',
                                            backgroundColor: '#F45354',
                                            borderRadius: '50%',
                                            border: '4px solid white',
                                            boxShadow: '0 0 0 4px #F45354'
                                        }}></div>
                                        <div className="timeline-content right" style={{ width: '45%' }}></div>
                                    </div>

                                    <div className="timeline-item" style={{
                                        display: 'flex',
                                        marginBottom: '4rem',
                                        position: 'relative',
                                        zIndex: 2
                                    }}>
                                        <div className="timeline-content left" style={{ width: '45%' }}></div>
                                        <div className="timeline-dot" style={{
                                            position: 'absolute',
                                            left: '50%',
                                            top: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            width: '20px',
                                            height: '20px',
                                            backgroundColor: '#F45354',
                                            borderRadius: '50%',
                                            border: '4px solid white',
                                            boxShadow: '0 0 0 4px #F45354'
                                        }}></div>
                                        <div className="timeline-content right" style={{
                                            width: '45%',
                                            paddingLeft: '6rem'
                                        }}>
                                            <div className="timeline-card" style={{
                                                backgroundColor: 'white',
                                                padding: '2rem',
                                                borderRadius: '15px',
                                                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                                                borderRight: '4px solid #F45354'
                                            }}>
                                                <div className="timeline-icon" style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    width: '60px',
                                                    height: '60px',
                                                    backgroundColor: '#F45354',
                                                    borderRadius: '50%',
                                                    marginBottom: '1rem'
                                                }}>
                                                    <FiBookOpen style={{ color: 'white', fontSize: '1.5rem' }} />
                                                </div>
                                                <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '0.5rem', color: '#242424' }}>
                                                    พ.ศ. 2564-2568
                                                </h3>
                                                <h4 style={{ fontSize: '1.2rem', fontWeight: '600', marginBottom: '1rem', color: '#F45354' }}>
                                                    การพัฒนาและปรับปรุง
                                                </h4>
                                                <p style={{ color: '#666', lineHeight: '1.6' }}>
                                                    การปรับปรุงและตกแต่งอาคารพิพิธภัณฑ์ การจัดทำนิทรรศการ และการลงนาม MOU กับมิวเซียมสยาม
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                {/* Detailed Content Section */}
                <div className="content-section ptb--50" style={{ backgroundColor: '#f8f9fa' }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                <div className="content-card" style={{
                                    backgroundColor: 'white',
                                    padding: '3rem',
                                    borderRadius: '20px',
                                    boxShadow: '0 15px 35px rgba(0,0,0,0.1)'
                                }}>
                                    <h2 style={{
                                        fontSize: '2rem',
                                        fontWeight: 'bold',
                                        color: '#242424',
                                        marginBottom: '2rem',
                                        textAlign: 'center'
                                    }}>
                                        เรื่องราวการก่อสร้าง
                                    </h2>
                                    
                                    <div className="content-paragraphs">
                                        <p style={{ color: '#666', lineHeight: '1.8', marginBottom: '1.5rem', fontSize: '1.5rem' }}>
                                            ในปี พ.ศ. 2560 ผู้ว่าราชการจังหวัดยโสธร นายบุญธรรม เลิศสุขีเกษม ได้ริเริ่มโครงการจัดสร้างพิพิธภัณฑ์เมืองเก่าบ้านสิงห์ท่า เพื่อเป็นศูนย์เรียนรู้ประวัติศาสตร์ท้องถิ่นบ้านสิงห์ท่าที่เป็นจุดเริ่มต้นของเมืองยโสธร ในการพิจารณาเลือกพื้นที่สำหรับการจัดสร้าง ได้คำนึงถึงความสำคัญในแง่ประวัติศาสตร์และความทรงจำของชุมชน พบว่ามีบริเวณพื้นที่ว่าง ตรงกันข้ามกับศาลเจ้าพ่อหลักเมือง ซึ่งเปรียบเสมือนใจกลางเมืองเก่าบ้านสิงห์ท่าพอดี จึงได้ขอใช้พื้นที่จากเทศบาลเมืองยโสธรในการจัดสร้างอาคารพิพิธภัณฑ์เมืองเก่าบ้านสิงห์ท่า
                                        </p>
                                        
                                        <p style={{ color: '#666', lineHeight: '1.8', marginBottom: '1.5rem', fontSize: '1.5rem' }}>
                                            การออกแบบอาคารพิพิธภัณฑ์เมืองเก่าบ้านสิงห์ท่าได้มี คุณตะวัน เลขาสถาพร สถาปนิกอิสระ เป็นผู้ออกแบบอาคารในรูปแบบโคโลเนี่ยล ที่มีความสอดคล้องประวัติศาสตร์ของพื้นที่และเคารพบริบทรอบข้าง ทำให้ตัวอาคารยืนโดดเด่น ทว่ากลมกลืนกับสถาปัตยกรรมตึกแถวดั้งเดิมที่ยังหลงเหลืออยู่ในปัจจุบัน การก่อสร้างแล้วเสร็จในปี พ.ศ. 2561 และพิพิธภัณฑ์ได้เปิดดำเนินการชั่วคราวเป็นระยะเวลาหนึ่ง จากนั้น ในปี พ.ศ. 2563 จังหวัดยโสธรได้ส่งมอบอาคารพิพิธภัณฑ์เมืองเก่าบ้านสิงห์ท่าให้เทศบาลเมืองยโสธรเป็นผู้ดูแล
                                        </p>
                                        
                                        <p style={{ color: '#666', lineHeight: '1.8', marginBottom: '1.5rem', fontSize: '1.5rem' }}>
                                            ในปี พ.ศ. 2564 นายกเทศมนตรีเมืองยโสธร นายณัฐพล นาคสุข ได้มอบหมายให้ ดร.นุชิดา สุวแพทย์ รองนายกเทศมนตรีเมืองยโสธร จัดทำโครงการปรับปรุงและตกแต่งอาคารพิพิธภัณฑ์เมืองเก่าบ้านสิงห์ท่า เพื่อปรับปรุงรูปแบบการนำเสนอและวิธีการจัดแสดงนิทรรการภายใน เพื่อให้เกิดความทันสมัยและส่งเสริมการเรียนรู้ประวัติศาสตร์ในรูปแบบใหม่
                                        </p>
                                        
                                        <p style={{ color: '#666', lineHeight: '1.8', marginBottom: '1.5rem', fontSize: '1.5rem' }}>
                                            เทศบาลเมืองยโสธรได้ลงนามบันทึกข้อตกลงความร่วมมือ พัฒนาแหล่งท่องเที่ยวเชิงประวัติศาสตร์ พิพิธภัณฑ์เมืองเก่าบ้านสิงห์ท่า ระหว่างเทศบาลเมืองยโสธร สถาบันพิพิธภัณฑ์การเรียนรู้แห่งชาติ (มิวเซียมสยาม) และคณะสถาปัตยกรรมศาสตร์ ผังเมือง และนฤมิตศิลป์ มหาวิทยาลัยมหาสารคาม เพื่อร่วมกันศึกษาและพัฒนาองค์ความรู้ทางประวัติศาสตร์ของเมืองเก่าบ้านสิงห์ท่า
                                        </p>
                                        
                                        <p style={{ color: '#666', lineHeight: '1.8', marginBottom: '1.5rem', fontSize: '1.5rem' }}>
                                            พิพิธภัณฑ์แห่งนี้ ได้จัดแสดงเนื้อหาเกี่ยวกับชุมชนเมืองเก่าบ้านสิงห์ท่า ที่มีประวัติศาสตร์ยาวนานมากกว่า 200 ปี ซึ่งเป็นจุดเริ่มต้นของจังหวัดยโสธร นับตั้งแแต่การเสี่ยงทายสร้างบ้านเมืองโดยท้าวคำสูเจ้าเมืองคนแรก จนกระทั่งเข้าสู่ช่วงของการเปลี่ยนแปลงรูปแบบชุมชนเป็นสังคมแห่งการค้าขายในเวลาต่อมา
                                        </p>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>

                <Footer />

                {/* Mobile Responsive CSS */}
                <style jsx>{`
                    @media (max-width: 768px) {
                        .timeline-container {
                            padding: 0 1rem;
                        }
                        
                        .timeline-item {
                            flex-direction: column !important;
                            align-items: center !important;
                        }
                        
                        .timeline-content.left,
                        .timeline-content.right {
                            width: 100% !important;
                            padding: 0 !important;
                            text-align: center !important;
                            margin-bottom: 1rem;
                        }
                        
                        .timeline-card {
                            width: 100% !important;
                            margin: 0 !important;
                            padding: 1.5rem !important;
                            border-radius: 12px !important;
                        }
                        
                        .timeline-line {
                            display: none !important;
                        }
                        
                        .timeline-dot {
                            display: none !important;
                        }
                        
                        .hero-title {
                            font-size: 2.5rem !important;
                        }
                        
                        .hero-subtitle {
                            font-size: 1rem !important;
                        }
                        
                        .title {
                            font-size: 2rem !important;
                        }
                        
                        .description {
                            font-size: 1.2rem !important;
                        }
                        
                        .content-card {
                            padding: 2rem 1.5rem !important;
                            margin: 0 1rem !important;
                        }
                        
                        .content-paragraphs p {
                            font-size: 1.2rem !important;
                        }
                    }
                    
                    @media (max-width: 480px) {
                        .timeline-card {
                            padding: 1rem !important;
                        }
                        
                        .hero-title {
                            font-size: 2rem !important;
                        }
                        
                        .title {
                            font-size: 1.8rem !important;
                        }
                        
                        .content-card {
                            padding: 1.5rem 1rem !important;
                        }
                    }
                `}</style>
            </React.Fragment>
        )
    }
}

export default MuseumHistory;
